module.exports = __webpack_public_path__ + "img/orders.51608269.gif";